shvenergy.basket = (function ($) {
	"use strict";

	function init() {

		var basketCookieNameContainer = $("[data-basketcookiename]");
		var numberOfItemsInBasket = "0";

		if (basketCookieNameContainer.length < 1)
			return;

		var basketCookieName = basketCookieNameContainer.data("basketcookiename");

		if (shvenergy.cookies.hasCookieCategoryConsent(basketCookieName)) {
			numberOfItemsInBasket = shvenergy.cookies.getCookie(basketCookieName);
			$("[data-basketcount]").text(numberOfItemsInBasket);
		}
	}

	init();

})(jQuery);